module.exports = __webpack_public_path__ + "img/zixun_bg_banner.min.a2857b13.jpg";